import React from 'react';
import './styles/app.scss';
import Header from './components/common-header/Header';
import Footer from './components/common-footer/Footer';
import Hero from './components/Hero/Hero';
import Intro from './components/Intro/Intro';
import { WidthContextProvider } from './WidthContext';
import Infographic from './components/Infographics/Infographic';
import Vimeo from './components/Vimeo/Vimeo';
import Hyperlink from './components/Hyperlink/Hyperlink';
import Panelists from './components/Panelists/Panelists';
import Chapters from './components/Chapters/Chapters';
import { lang } from './components/lang';

function App() {
  const { cta, button } = lang;

  return (
    <WidthContextProvider>
      <div className="App">
        <Header clientName="Regeneron" />
        <Hero />
        <Intro />
        <Panelists />
        <Chapters />
        <Infographic />
        <p className="App__cta">
          {cta.copy1}
          <Hyperlink hyperlinkData={cta} />
          {cta.copy2}
        </p>
        <Vimeo />
        <a className="App__button" href={button.href} target="_blank" rel="sponsored noopener">
          <span className="App__button__text">{button.copy}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="27"
            viewBox="0 0 17 27"
            fill="none"
          >
            <path d="M2 25.7538L14 13.8769L2 2" stroke="white" strokeWidth="3" />
          </svg>
        </a>
        <Footer />
      </div>
    </WidthContextProvider>
  );
}

export default App;
